<template>
  <div class="vue-tempalte vertical-center inner-block">
    <h3>{{ $t("LOGIN") }}</h3>
    <b-form @submit.prevent="login">
      <b-form-group :label="$t('EMAIL')"  label-for="email">
        <b-form-input
          id="email"
          type="email"
          class="form-control mt-2 mb-3"
          v-model="username"
          required
        />
      </b-form-group>
      <b-form-group :label="$t('PASSWORD')" label-for="password">
        <b-form-input
          id="password"
          type="password"
          class="form-control mt-2 mb-3"
          v-model="password"
          minlength="6"
          required
        />
      </b-form-group>
      <b-button type="submit" variant="primary"> {{ $t("LOGIN_BUTTON") }} </b-button>
    </b-form>
    <b-container class="d-flex justify-content-end">
      <b-link to="/singup">{{ $t("CREATE_ACCOUNT") }}</b-link>
    </b-container>
    <b-container class="d-flex justify-content-end">
      <b-link to="/ForgetPassword">{{ $t("FORGOT_PASS") }}</b-link>
    </b-container>
    <div class="label_rule">
      <b-link
        href="https://www.vestone.co.jp/press/privacy/index.html"
        class="text-secondary"
        >{{ $t("POLICY") }}</b-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      showError: false,
      errorMessage: "",
    };
  },
  methods: {
    login() {
      let self = this;
      this.$cognito
        .login(this.username, this.password)
        .then((result) => {
          this.$router.replace("/editor");
        })
        .catch((err) => {
          alert(err.message);
        });
    },
  },
};
</script>
<style scoped>
.label_rule {
  text-align: center;
  margin-bottom: -40px;
  padding-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue